import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { loginRoutine } from 'state/account/account.routines';
import { authTokenSelector } from 'state/account/account.selectors';

import Page from 'components/page/page.component';

import SignInForm from 'components/sign-in-form/sign-in-form.component';

import './style.css';

const SignIn = () => {
    const dispatch = useDispatch();
    const { token } = useSelector(authTokenSelector);

    const handleSubmit = (values) => {
        dispatch(loginRoutine.trigger(values));
    };

    if (token) {
        return <Redirect to="/admin/bids" />;
    }

    return (
        <Page className="account" heroTitle="Sign In" heroSize="small" variant="no-flex">
            <SignInForm onSubmit={handleSubmit} />
        </Page>
    );
};

export default SignIn;
